var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-container" },
    [
      _c("div", { staticClass: "order-header" }, [
        _c("div", { staticClass: "rest-name-section" }, [
          _c("span", { staticClass: "order-name" }, [
            _vm._v(_vm._s(_vm.order.restaurantName)),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "order-action",
              attrs: {
                href: _vm.order.restMenuUrl,
                "aria-label": `Add More Items from ${_vm.order.restaurantName}`,
              },
            },
            [
              _c(
                "icon-base",
                {
                  staticClass: "order-action-icon",
                  attrs: { width: "12", height: "12", iconName: "Add Items" },
                },
                [_c("icon-plus-circle")],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "order-action-text" }, [
                _vm._v("Add More Items"),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "clear-all-section",
            attrs: {
              "aria-label": `Clear all ${_vm.order.restaurantName} items from cart.`,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("clear-order", _vm.order.id)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.$emit("clear-order", _vm.order.id)
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-trash fa-lg" }),
            _vm._v("\n      Clear All\n    "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("cart-items", {
        attrs: { items: _vm.order.items, restId: _vm.order.id },
        on: {
          "edit-item": _vm.handleEditItem,
          "remove-item": _vm.handleRemove,
          "edit-item-qty": _vm.handleEditItemQty,
          "close-cart": function ($event) {
            return _vm.$emit("close-cart")
          },
        },
      }),
      _vm._v(" "),
      _vm.showStaffCartInfo
        ? _c("cart-instructions", {
            attrs: {
              specialInstructions: _vm.order.specialInstructions,
              restId: _vm.order.id,
              label: "Special Instructions for " + _vm.order.restaurantName,
              disabledLabel:
                _vm.order.restaurantName +
                " does not allow Special Instructions at this time",
              allowOrderNotes: _vm.order.allowOrderNotes,
              placeholder: "Dressing on the side",
            },
            on: { updateRestComment: _vm.handleUpdateRestComment },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }